import React from 'react';
import { useApp } from '../context/AppContext';
import { roleLabel } from '../utils/helpers';

export default function Sidebar({ nav, active, setActive }) {
  const { currentUser, logout } = useApp();
  const initials = currentUser ? currentUser.name.split(' ').map(n => n[0]).join('').slice(0,2).toUpperCase() : '';
  return (
    <div style={{ width: 220, minHeight: '100vh', background: '#1C1B2E', display: 'flex', flexDirection: 'column', flexShrink: 0, position: 'sticky', top: 0, height: '100vh' }}>
      <div style={{ padding: '24px 20px 16px' }}>
        <div style={{ fontSize: 15, fontWeight: 700, color: '#fff', letterSpacing: 0.3 }}>WM Payments</div>
        <div style={{ fontSize: 11, color: '#8887a8', marginTop: 2 }}>Payment Workflow Tool</div>
      </div>
      <div style={{ padding: '8px 12px 12px', borderBottom: '1px solid #2e2d46' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 8px', background: '#2e2d46', borderRadius: 8 }}>
          <div style={{ width: 32, height: 32, borderRadius: '50%', background: '#534AB7', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 600, color: '#fff', flexShrink: 0 }}>{initials}</div>
          <div style={{ overflow: 'hidden' }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: '#fff', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{currentUser?.name}</div>
            <div style={{ fontSize: 11, color: '#8887a8' }}>{roleLabel(currentUser?.role)}</div>
          </div>
        </div>
      </div>
      <nav style={{ flex: 1, padding: '12px 12px' }}>
        {nav.map(item => (
          <button key={item.id} onClick={() => setActive(item.id)}
            style={{ display: 'flex', alignItems: 'center', gap: 10, width: '100%', padding: '9px 12px', borderRadius: 8, marginBottom: 2,
              background: active === item.id ? '#534AB7' : 'transparent', color: active === item.id ? '#fff' : '#aaa9c8',
              border: 'none', cursor: 'pointer', textAlign: 'left', fontSize: 13, fontWeight: active === item.id ? 600 : 400 }}>
            <span style={{ fontSize: 16 }}>{item.icon}</span>
            {item.label}
            {item.badge > 0 && <span style={{ marginLeft: 'auto', background: '#E24B4A', color: '#fff', borderRadius: 10, padding: '1px 7px', fontSize: 11, fontWeight: 600 }}>{item.badge}</span>}
          </button>
        ))}
      </nav>
      <div style={{ padding: '12px 12px 20px' }}>
        <button onClick={logout} style={{ width: '100%', padding: '9px 12px', borderRadius: 8, background: 'transparent', color: '#8887a8', border: '1px solid #2e2d46', cursor: 'pointer', fontSize: 13, display: 'flex', alignItems: 'center', gap: 8 }}>↩ Sign out</button>
      </div>
    </div>
  );
}
